import React from 'react'
import { DialogActions, DialogActionsProps } from '@mui/material'

export default function AppDialogActions({
    children,
    ...rest
}: DialogActionsProps) {
    return (
        <DialogActions sx={{ p: 2 }} {...rest}>
            {children}
        </DialogActions>
    )
}
